// extracted by mini-css-extract-plugin
module.exports = {"animationWrapper":"rivermini_animationWrapper__Kl_Hl"};